import { getEmptyGroup } from '../../utils'
import type { FormattedTeamPerson } from '../team_people/types'
import { FormattedTeam, RawTeamData } from './types'

// "No team" sentinel; a not-found team has no sport.
export const EMPTY_RAW_TEAM_DATA: RawTeamData = {
  id: '',
  name: '',
  color: '',
  logo: '',
  sport: null,
  gender: 'Male',
  level: 'Unknown',
  competesIn: [],
  teamPeople: []
}

// "No team" sentinel; a not-found team has no sport.
export const EMPTY_FORMATTED_TEAM: FormattedTeam = {
  id: '',
  rawData: EMPTY_RAW_TEAM_DATA,
  name: '',
  color: '',
  logo: '',
  teamPeople: getEmptyGroup<FormattedTeamPerson>(),
  gender: 'male',
  sport: null,
  sportType: null
}
